import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//components:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getTiposPartida, modifyTipoPartida, removeTipoPartida, addTipoPartida, updateTiposPartidaDB } from '../../actions/tipos_partida_actions';
import { getGrupoPartida } from '../../actions/grupo_partida_actions'

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';


import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    marginBottom: {
        marginBottom: 20,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresTipoPartida extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }


        this.props.getGrupoPartida();
        this.props.getTiposPartida();
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkCvTipoPartida = (tipoPartida) => {
        if (this.props.tiposPartida.find(tp => (tp.descr === tipoPartida.descr) && (tp.id !== tipoPartida.id))) {
            this.messageDialog(`Ya existe un tipo de partida ${tipoPartida.descr}`);
            return false;
        } else if (!tipoPartida.descr.trim()) {
            this.messageDialog('Por favor, introduzca una descripción');
            return false;
        } else if (isNaN(tipoPartida.divisor)) {
            this.messageDialog('Por favor, introduzca un divisor');
            return false;
        }

        else return true;
    };

    editTipoPartida = (tipoPartida) => {

        this.props.openDialog('EditCvTipoPartida', {
            cvTipoPartida: tipoPartida,
            checkTipoPartida: this.checkCvTipoPartida,
            okHandler: (tp) => {
                this.props.setSaveState(true);
                this.props.modifyTipoPartida(tp);
            },
            grupoPartida: this.props.grupoPartida

        }, uuidv4());
    };

    newTipoPartida = () => {
        this.props.openDialog('EditCvTipoPartida', {
            cvTipoPartida: {},
            checkTipoPartida: this.checkCvTipoPartida,
            okHandler: (tp) => {
                this.props.setSaveState(true);
                this.props.addTipoPartida(tp);
            },
            grupoPartida: this.props.grupoPartida
        }, uuidv4());
    };

    handleGridRowsUpdated = ({ fromRow, toRow, fromRowData, updated }) => {

        if (fromRow !== toRow) return; //solo modificamos una fila

        // for (let i = fromRow; i <= toRow; i++) {
        //     let updatedRow = update(this.props.tiposPartida[i], { $merge: updated });
        //     this.props.setSaveState(true);
        //     this.props.modifyTipoPartida(updatedRow);
        // }

        let updatedRow = update(this.props.tiposPartida[fromRowData.grid_index], { $merge: updated });
        this.props.setSaveState(true);
        this.props.modifyTipoPartida(updatedRow);

    };

    handleDeleteRow = tipoPartida => {
        this.props.setSaveState(true);
        this.props.removeTipoPartida(tipoPartida);
    };

    render() {

        const { classes } = this.props;



        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div className={classes.marginBottom}>
                    <NeuriteGrid
                        id="m_a_t_p"
                        columns={[
                            { key: 'cvGrupoPartidaDescr', name: 'Grupo Partida', editable: false, dragable: false, width: 115 },
                            { key: 'descr', name: 'Descripción', editable: true, dragable: false, width: 115 },
                            { key: 'divisor', name: 'Divisor', tooltip: 'Número de partidas asociado a este tipo', editable: true, dragable: false, type: 'int', width: 60 }
                        ]}
                        rows={this.props.tiposPartida}
                        height={500}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newTipoPartida}
                        onEditClick={this.editTipoPartida}
                        onRowsUpdated={this.handleGridRowsUpdated}
                        onDeleteClick={this.handleDeleteRow}
                        enableFilter={true}

                    />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.tiposPartida.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateTiposPartidaDB(this.props.tiposPartida)
                }
                }>Guardar</Button>
            </div>
        );

    };

};

MaeAuxiliaresTipoPartida.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    tiposPartida: PropTypes.array.isRequired,
    grupoPartida: PropTypes.array.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getGrupoPartida: PropTypes.func.isRequired,
    getTiposPartida: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifyTipoPartida: PropTypes.func.isRequired,
    removeTipoPartida: PropTypes.func.isRequired,
    addTipoPartida: PropTypes.func.isRequired,
    updateTiposPartidaDB: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        tiposPartida: state.tiposPartida.tipospartida,
        grupoPartida: state.grupoPartida.grupospartida,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getTiposPartida,
        getGrupoPartida,
        openDialog,
        hideDialog,
        modifyTipoPartida,
        removeTipoPartida,
        addTipoPartida,
        updateTiposPartidaDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresTipoPartida));

